<div class="p-grid">
    <div class="p-col-12 p-field">
        <label for="mailAccount">Cuenta de correo</label>
        <p-dropdown name="mailAccount" optionValue="id" [options]="mailAccounts" [(ngModel)]="userMailAccount.mailAccount_id" optionLabel="name" appendTo="body" placeholder="Selecciona una cuenta de correo"></p-dropdown>
    </div>
    <div class="p-col-12">
        <button pButton class="p-ml-2" style="float: right;" (click)="save()" icon="pi pi-check"
            label="Guardar"></button>
        <button pButton class="p-button-secondary p-button-text" style="float: right;" (click)="cancel()" icon="pi pi-times"
            label="Cancelar"></button>
    </div>
</div>